import { render, staticRenderFns } from "./DailyBonusItem.vue?vue&type=template&id=64d2b262&scoped=true"
import script from "./DailyBonusItem.vue?vue&type=script&lang=js"
export * from "./DailyBonusItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d2b262",
  null
  
)

export default component.exports